/**
 * ICE-серверы для RTCPeerConnection (CONTRACT §7).
 * Если задан VUE_APP_ICE_SERVERS (JSON-массив RTCIceServer) — используем его,
 * иначе — текущий захардкоженный список (должен продолжать работать в проде).
 */

const DEFAULT_ICE_SERVERS = [
  {
    urls: "stun:77.233.221.18:3478",
  },
  {
    urls: "turn:77.233.221.18:3478?transport=udp",
    username: "webrtc",
    credential: "gdhjgsfjkdhk128djf7",
  },
  {
    urls: "turn:77.233.221.18:3478?transport=tcp",
    username: "webrtc",
    credential: "gdhjgsfjkdhk128djf7",
  },
];

/** @returns {RTCIceServer[]} */
export function getIceServers() {
  const raw = (process.env.VUE_APP_ICE_SERVERS || "").trim();
  if (raw) {
    try {
      const parsed = JSON.parse(raw);
      if (Array.isArray(parsed) && parsed.length) return parsed;
    } catch (e) {
      console.error("[ice] VUE_APP_ICE_SERVERS не является JSON-массивом, используем список по умолчанию");
    }
  }
  return DEFAULT_ICE_SERVERS.map((server) => ({ ...server }));
}

export default getIceServers;
